import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CREATE_QUOTATION_CUTOMER = "CREATE_QUOTATION_CUTOMER";
export const CREATE_QUOTATION_CUTOMER_LOADING =
"CREATE_QUOTATION_CUTOMER_LOADING";
export const CREATE_QUOTATION_CUTOMER_LOADING_FAILED =
"CREATE_QUOTATION_CUTOMER_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const createQuotationCustomerLoading = ms => ({
    type: CREATE_QUOTATION_CUTOMER_LOADING,
    payload: ms
    });
    
    export const createQuotationCustomerLoadingFailed = ms => ({
    type: CREATE_QUOTATION_CUTOMER_LOADING_FAILED,
    payload: ms
    });

export function createQuotationCustomer(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/createQuotation`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(createQuotationCustomerLoading());
  
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response createQuotationCustomer")
    dispatch({
    type: CREATE_QUOTATION_CUTOMER,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        createQuotationCustomerLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(createQuotationCustomerLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(createQuotationCustomerLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(createQuotationCustomerLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


